/* ============================================================
   TYTAN Contractor Case — scoped landing-page behavior.
   - FAQ accordion (one open at a time, first open by default)
   - Before/After drag slider
   - Add-to-cart (quantity 12) with loading/success/error states,
     theme cart-drawer refresh, and 422 low-stock fallback.
   Everything is namespaced; no globals leak.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.tccInit === '1') return;
    root.dataset.tccInit = '1';

    initFaq(root);
    initBeforeAfter(root);
    initCart(root);
    initSticky(root);
  }

  /* ---------------- mobile sticky buy bar ---------------- */
  function initSticky(root) {
    var bar = root.querySelector('.tcc-sticky');
    if (!bar) return;
    var toggle = function () { bar.classList.toggle('is-visible', window.scrollY > 640); };
    toggle();
    window.addEventListener('scroll', toggle, { passive: true });
    window.addEventListener('resize', toggle);
  }

  /* ---------------- FAQ accordion ---------------- */
  function initFaq(root) {
    var buttons = root.querySelectorAll('.tcc-faq__q');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        // close all
        buttons.forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var body = b.parentElement.querySelector('.tcc-faq__body');
          if (body) body.setAttribute('data-open', '0');
        });
        // open this one (unless it was already open)
        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          var body = btn.parentElement.querySelector('.tcc-faq__body');
          if (body) body.setAttribute('data-open', '1');
        }
      });
    });
  }

  /* ---------------- Before / After slider ---------------- */
  function initBeforeAfter(root) {
    var range = root.querySelector('.tcc-ba__range');
    if (!range) return;
    var after = root.querySelector('.tcc-ba__after');
    var line = root.querySelector('.tcc-ba__line');
    function update() {
      var v = Number(range.value);
      if (after) after.style.clipPath = 'inset(0 0 0 ' + v + '%)';
      if (line) line.style.left = v + '%';
    }
    range.addEventListener('input', update);
    update();
  }

  /* ---------------- Add to cart ---------------- */
  function initCart(root) {
    var LOW_STOCK_MSG =
      "Low stock — fewer than 12 cans available right now. Call +1 (678) 541-0303 and we'll get you sorted.";

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tcc-add]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      if (btn.classList.contains('is-loading') || btn.disabled) return;

      var variantId = btn.getAttribute('data-variant-id');
      var qty = parseInt(btn.getAttribute('data-quantity'), 10) || 12;
      var label = btn.querySelector('[data-tcc-label]');
      var group = btn.closest('[data-tcc-cta]');
      var msg = group ? group.querySelector('[data-tcc-stock]') : null;
      var original = label ? label.textContent : '';

      if (!variantId) return;
      if (msg) msg.hidden = true;

      btn.classList.add('is-loading');
      if (label) label.textContent = 'Adding…';

      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] }),
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().catch(function () { return {}; }).then(function (data) {
              var err = new Error('add-failed');
              err.status = res.status;
              err.data = data;
              throw err;
            });
          }
          return res.json();
        })
        .then(function () {
          btn.classList.remove('is-loading');
          if (label) label.textContent = 'Added — ' + qty + ' cans in cart';
          refreshCart();
          setTimeout(function () {
            if (label) label.textContent = original;
          }, 3000);
        })
        .catch(function (err) {
          btn.classList.remove('is-loading');
          if (label) label.textContent = original;
          // 422 = not enough stock; any error → show the call-us message
          if (msg) {
            var text = err && err.data && err.data.description ? err.data.description : LOW_STOCK_MSG;
            // Prefer our branded message for the stock case; keep Shopify's only if it's not generic.
            msg.textContent = err && err.status === 422 ? LOW_STOCK_MSG : (text || LOW_STOCK_MSG);
            msg.hidden = false;
          }
        });
    });
  }

  function refreshCart() {
    if (document.querySelector('cart-drawer')) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
    } else {
      var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
      window.location = root + 'cart';
    }
  }

  /* ---------------- boot ---------------- */
  function boot() {
    document.querySelectorAll('.tcc').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init inside the Shopify theme editor when the section is reloaded.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.tcc');
    if (el) init(el);
  });
})();
